// extracted by mini-css-extract-plugin
module.exports = {"button":"GenderButton-button-39c2","regular":"GenderButton-regular-39c2","active":"GenderButton-active-39c2","tsum":"GenderButton-tsum-39c2"};